import { render, staticRenderFns } from "./exchange.vue?vue&type=template&id=6874fe46&"
import script from "./exchange.ts?vue&type=script&lang=ts&"
export * from "./exchange.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "exchange.vue"
export default component.exports